import { MapPin, Ticket as TicketIcon } from "lucide-react";
import { useCourtyard } from "@/context/CourtyardContext";
import { formatDate, formatTime, mapLink } from "@/lib/event";
import CalendarMenu from "@/components/invite/CalendarMenu";

function Row({ label, value, note, className = "", testid }) {
  return (
    <div className={`border-t-2 border-[rgba(255,247,232,.18)] pt-3 ${className}`} data-testid={testid}>
      <dt className="eyebrow eyebrow-light">{label}</dt>
      <dd className="font-poster mt-1 text-[1.7rem] leading-[1.02] text-[var(--cream)] sm:text-3xl">{value}</dd>
      {note && <dd className="font-serif-i mt-1 text-lg leading-snug text-[#F3EAD8]">{note}</dd>}
    </div>
  );
}

export default function Ticket() {
  const { event: ev, openRsvp, rsvp } = useCourtyard();
  const map = mapLink(ev);
  return (
    <article className="pop on-dark relative bg-[var(--navy)] text-[var(--cream)] lg:rotate-[1.2deg]" aria-label="Event details" data-testid="event-ticket">
      <header className="bg-pink-print relative flex items-center justify-between gap-3 overflow-hidden rounded-t-[17px] border-b-[2.5px] border-[var(--navy)] px-5 py-3">
        <div className="dots-cream absolute inset-0" aria-hidden="true" />
        <span className="font-poster relative text-xl tracking-wide">Shaam ka pass</span>
        <span className="relative flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-[0.18em] text-[var(--yellow)]"><TicketIcon className="h-4 w-4" aria-hidden="true" /> Admit you + drama</span>
      </header>
      <dl className="grid gap-x-6 gap-y-4 px-5 pb-5 pt-4 sm:grid-cols-2 sm:px-7">
        <Row label="Kab?" value={formatDate(ev.date)} note={ev.date_note} className="sm:col-span-2" testid="hero-date" />
        <Row label="Kitne baje?" value={formatTime(ev.start_time)} note={ev.start_note} testid="hero-time" />
        <Row label="Kahan?" value={ev.venue_title} note={ev.venue_label} testid="hero-venue" />
      </dl>
      <div className="relative mx-5 border-t-[3px] border-dashed border-[rgba(255,247,232,.45)]" aria-hidden="true">
        <span className="absolute -left-[38px] -top-[17px] h-8 w-8 rounded-full border-[2.5px] border-[var(--navy)] bg-[var(--cream)]" />
        <span className="absolute -right-[38px] -top-[17px] h-8 w-8 rounded-full border-[2.5px] border-[var(--navy)] bg-[var(--cream)]" />
      </div>
      <div className="flex flex-col gap-3 px-5 pb-6 pt-5 sm:px-7">
        <button type="button" onClick={openRsvp} className="btn-primary min-h-[58px] w-full text-base sm:text-lg" data-testid="rsvp-open-button">
          {rsvp ? "Update my RSVP" : "RSVP: main aa rahi/raha hoon."}
        </button>
        <div className="grid grid-cols-2 gap-3">
          {map && (
            <a href={map} target="_blank" rel="noopener noreferrer" className="btn-ghost whitespace-nowrap px-3 text-sm sm:text-base" data-testid="open-map-button">
              <MapPin className="h-4 w-4" aria-hidden="true" /> Open map
            </a>
          )}
          <CalendarMenu className="btn-ghost whitespace-nowrap px-3 text-sm sm:text-base" />
        </div>
        <p className="text-center text-xs text-[#E5DFD2]">Exact location opens in the map. Address sirf mehmaanon ke liye.</p>
      </div>
    </article>
  );
}
